import React from 'react';
import * as BookApi from 'api/Book';
import useRouter from 'hooks/useRouter';
import { GetServerSideProps, NextPage } from 'next';
import { useEffect } from 'react';
import { Analytics, Events } from 'src/services/analytics';
import { slugify } from 'utils/global';
import MasterBookAuthorPage from 'src/page-components/books/MasterBookAuthorPage';
import { PublisherBookApiResponse } from 'api/api.types';
import { getBookAuthorPageMetadata } from 'utils/metadata.utils';

interface InitialProps {
  publisher: PublisherBookApiResponse;
}

const BookDynamicPage: NextPage<InitialProps> = ({ publisher }) => {
  const router = useRouter();

  useEffect(() => {
    if (publisher) {
      const { utm_source, utm_medium } = router.query;
      Analytics.logEvent({
        eventName: Events.consumption.viewBookAuthorPage,
        properties: {
          publisherId: publisher.id,
          name: publisher.name,
          ...(typeof utm_source === 'string' ? { utm_source } : {}),
          ...(typeof utm_medium === 'string' ? { utm_medium } : {}),
        },
        platforms: ['amplitude'],
      });
    }
  }, [publisher]);

  return (
    <MasterBookAuthorPage
      publisher={publisher}
      pageMetadata={getBookAuthorPageMetadata({ publisher: publisher })}
    />
  );
};

export const getServerSideProps: GetServerSideProps<InitialProps> = async ({
  params,
  req,
}) => {
  if (!params) return { notFound: true };

  const publisherId = Number(params.id as string);

  const publisher = await BookApi.getBookPublisher({
    publisherId,
    nextRequest: req,
  }).catch(_ => undefined);

  if (!publisher) {
    return { notFound: true };
  }
  const slug = slugify(publisher.name);

  if (params.slug !== slug) {
    //Redirect to the correct slug
    return {
      redirect: {
        destination: `/book/author/${publisherId}/${slug}`,
        statusCode: 301,
      },
    };
  }

  return {
    props: {
      publisher,
    },
  };
};

export default BookDynamicPage;
